export enum RoleEnum {
  ADMIN = "admin",
  CLIENT = "client",
  ACCOUNTANT = "accountant",
  SELLER = "seller"
}
